export default __webpack_public_path__ + "static/media/ic_ftm_16.9a43ded2.svg";